import notesErrorReducer from "@store/Store/Data/NotesError/NotesErrorReducer";
import priceToggleReducer from "@store/Store/Data/PriceToggle/PriceToggleReducer";
import { combineReducers } from "redux";

const dataReducers = {
    priceToggle: priceToggleReducer,
    checkout: notesErrorReducer,
};

export type DataReducers = typeof dataReducers;

const dataReducer = combineReducers(dataReducers as any);
export default dataReducer;
